export interface ContractorDocument {
  id: string;
  documentType: ContractorDocumentType;
  documentTypeDisplay: string;
  fileName: string;
  isVerified: boolean;
  expirationDate: string;
  uploadedAt: string;
  isExpired: boolean;
  isExpiringSoon: boolean;
  previewUrl: string;
}

export interface ContractorDocumentPayload {
  documentType: ContractorDocumentType;
  fileName: string;
  fileContent: string;
  mimeType?: string;
  expirationDate?: string;
}

export enum ContractorDocumentType {
  DRIVERS_LICENSE = 'DriversLicense',
  W9_FORM = 'W9Form',
  DIRECT_DEPOSIT_FORM = 'DirectDepositForm',
  CONTRACTOR_AGREEMENT = 'ContractorAgreement',
  BLS_CERTIFICATION = 'BlsCertification',
  CPR_CERTIFICATION = 'CprCertification',
  IMMUNIZATION_RECORDS = 'ImmunizationRecords',
  MEDICAL_LICENSE = 'MedicalLicense',
  BACKGROUND_CHECK = 'BackgroundCheck',
  PHOTO_ID = 'PhotoId',
  OTHER_CERTIFICATION = 'OtherCertification',
  I9_FORM = 'I9Form'
}
